import useSWR from 'swr'

import { useApis } from '../contexts/api-context'
import { useSession } from '../contexts/session-context'
import { type ReviewType } from '../types/TherapistStateType'

export const fetchFeedback = async (api: any, therapistId: number, isLoggedIn: boolean): Promise<ReviewType> => {
  if (!isLoggedIn || !therapistId) return null

  const res = await api.getFeedback(therapistId)
  return res.data
}

const useFeedback = (therapistId: number) => {
  const { api } = useApis()
  const { isLoggedIn } = useSession()

  const { data, mutate, error } = useSWR(
    ['feedback', therapistId, isLoggedIn],
    () => {
      return fetchFeedback(api, therapistId, isLoggedIn)
    },
    {
      refreshInterval: 0,
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  )

  return {
    feedback: data,
    mutate: (data: ReviewType) => mutate(data, { revalidate: false }),
    isLoading: !error && !data,
  }
}

export default useFeedback
